import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {DocumentRequirementRegistration} from "../../models/document_requirement_registration";
import Helpers from "../../utils/helpers";

@Injectable()
export class DocumentRegistrationsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getDocumentRequestRegistrationsList(serviceId: string): Observable<DocumentRequirementRegistration[][]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/document_requirement_registration") as Observable<DocumentRequirementRegistration[][]>;
  }

  public saveRequestRegistrations(documentRequirementRegistration: DocumentRequirementRegistration) {
    Helpers.trimRecursiveObj(documentRequirementRegistration);
    const body = JSON.stringify(documentRequirementRegistration);
    return this.http.post(this.baseUrl + "document_requirement_registration", body, {responseType: "text"});
  }
}
